import { render, staticRenderFns } from "./MioTrainerCoordinatorPerformance.vue?vue&type=template&id=843e9706&"
import script from "./MioTrainerCoordinatorPerformance.vue?vue&type=script&lang=js&"
export * from "./MioTrainerCoordinatorPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports